/**
 * Team Access refresh policy while an invite is outstanding (UX sheet r244):
 * no push channel tells the inviter that an invite was accepted, so the roster
 * re-polls on this interval until no pending invite remains.
 */
export const TEAM_PENDING_INVITES_POLL_MS = 30_000;
